/**
 * Represents the type of the relationship field.
 */
export const enum RelationshipFieldType {
  MANY_TO_ONE = 'belongsTo',
  ONE_TO_MANY = 'hasMany',
  MANY_TO_MANY = 'manyToMany',
}

export const enum SimpleField {
  /** Image object, like {
    "url": "https://s3.ap-northeast-1.amazonaws.com/staging.click-platform.dbfile/user18/2022/04/04/e715cc9d-9b2f-45c3-9614-d9fb91e55fa0.png",
    "size": 32288,
    "filename": "test.png"
  } */
  IMAGE = 'image',

  /** File object, like {
    "url": "https://s3.ap-northeast-1.amazonaws.com/dev.click-platform.dbfile/user1467/2023/05/08/af10fb211de.csv",
    "size": 0,
    "filename": "test.csv"
  } */
  FILE = 'file',

  /** String */
  STRING = 'string',

  /** MD5 Encryption */
  PASSWORD = 'password',

  /** Full date, like '2023-04-18T04:41:30.882Z' */
  DATE_TIME = 'date',

  /** Date only, like '2023-04-18' */
  DATE_ONLY = 'dateOnly',

  /** Number */
  NUMBER = 'number',

  /** Boolean */
  BOOLEAN = 'boolean',
}

/**
 * Represents the type information of the relationship field.
 */
export type RelationshipField = {
  type: RelationshipFieldType;
  tableId: string;
};

/**
 * Represents the type information of the field.
 */
export type FieldType = SimpleField | RelationshipField;

/**
 * Represents the information of the field.
 */
export type Field = {
  /** True if the field is the default of the table. */
  default: boolean;

  /** The type information of the field. */
  type: FieldType;

  /** The field's name. */
  name: string;

  /** The field's id. */
  fid: string;

  /** True if the field will hide when selecting. */
  hidden?: boolean;

  /** True if the field is primary key. */
  primary?: boolean;

  /** True if the field is not null. */
  not_null?: boolean;

  /** True if the field is unique. */
  unique?: boolean;

  /** The field's max length. */
  length?: number;

  /** The field's key. */
  key?: string;

  /** True if the field is showed on admin page. */
  showTab?: boolean;
};

/**
 * Represents the table containing the collection's information of the app.
 */
export interface AppDatabase {
  /** The collection's id. */
  appDatabaseId: number;

  /** The id of the app containing the collection. */
  appId: number;

  /** The collection's column is used in Zapier */
  databaseColumn: string;

  /** The collection's name. */
  databaseName: string;

  /** True if the collection is a favorite collection.(Admin page) */
  favorite: boolean;

  /** True if the collection is a external collection. */
  isThirdParty: boolean;

  /** True if the collection is a v3 collection. */
  newVersion: boolean;

  /** True if the collection is a user's collection. */
  root: boolean;

  /** The collection's metadata. This is collection's config If the collection is a external database, Zapier's data otherwise. */
  databaseMetadata?: string;

  /** The collection's uuid.
   * - maxLength: 100 */
  databaseUuid: string;

  /** The collection's fields. */
  fields: Field[];

  /** The collection's created at.
   * - Format: date-time */
  createdAt: string;

  /** The collection's deleted at.
   * - Format: date-time */
  updatedAt: string;

  /** The collection's deleted at.
   * - Format: date-time */
  deletedAt?: string;
}
